// import './pop-up.scss'
import React, { useEffect, useRef } from 'react'

const HowToget = ({ setOpenBonus }) => {
  const modalRef = useRef(null)

  const onClose = () => {
    setOpenBonus(false)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  return (
    <>
      <div className="loginPopUp">
        <div className={`pop-up_wrapper `} style={{ left: 0 }}>
          <div className="modal-overlay">
            <div ref={modalRef} className={`pop-up pop_affi login-desktop`}>
              <div className="closePopUpButton" onClick={onClose}>
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="15.5" cy="15.5" r="15.5" fill="#142326" />
                  <path
                    d="M11.2045 10.0005C10.9659 10.0008 10.7328 10.0722 10.5349 10.2057C10.3371 10.3391 10.1835 10.5285 10.0938 10.7496C10.0042 10.9707 9.98244 11.2136 10.0314 11.4471C10.0804 11.6806 10.1979 11.8943 10.3689 12.0607L13.7205 15.4122L10.3689 18.7638C10.2538 18.8744 10.1618 19.0068 10.0985 19.1534C10.0351 19.2999 10.0017 19.4576 10.0001 19.6173C9.99844 19.7769 10.0287 19.9353 10.089 20.0831C10.1494 20.2309 10.2386 20.3652 10.3515 20.4781C10.4644 20.591 10.5987 20.6802 10.7465 20.7406C10.8943 20.8009 11.0527 20.8312 11.2123 20.8296C11.372 20.8279 11.5297 20.7945 11.6763 20.7311C11.8228 20.6678 11.9552 20.5758 12.0658 20.4607L15.4174 17.1091L18.7689 20.4607C18.8795 20.5758 19.012 20.6678 19.1585 20.7311C19.3051 20.7945 19.4628 20.8279 19.6224 20.8296C19.7821 20.8312 19.9405 20.801 20.0883 20.7406C20.2361 20.6803 20.3704 20.591 20.4833 20.4781C20.5962 20.3652 20.6854 20.2309 20.7457 20.0831C20.8061 19.9353 20.8363 19.7769 20.8347 19.6173C20.8331 19.4577 20.7996 19.2999 20.7363 19.1534C20.6729 19.0068 20.581 18.8744 20.4658 18.7638L17.1143 15.4122L20.4658 12.0607C20.6392 11.8921 20.7577 11.6751 20.8056 11.4381C20.8536 11.2011 20.8288 10.9551 20.7345 10.7324C20.6403 10.5097 20.481 10.3206 20.2774 10.19C20.0739 10.0595 19.8357 9.99339 19.5939 10.0005C19.2822 10.0098 18.9863 10.1401 18.7689 10.3638L15.4174 13.7154L12.0658 10.3638C11.9539 10.2487 11.8199 10.1573 11.672 10.0949C11.524 10.0325 11.3651 10.0004 11.2045 10.0005V10.0005Z"
                    fill="#fff"
                  />
                </svg>
              </div>

              <div className="signUpNew_wrapper">
                <div
                  className="signUpNew_header__title"
                  style={{
                    textAlign: 'left',
                    marginTop: '12px',
                    marginBottom: '0px',
                  }}
                >
                  How to get bonus?
                </div>
                <ul
                  className="affi-how-bonus-list affi-how-to-get-bonus"
                  style={{
                    height: '80vh',
                    overflow: 'scroll',
                    marginTop: '0px',
                  }}
                >
                  <h5>🧾 Affiliate Program – How It Works</h5>
                  <li>Earn daily bonus by inviting users to play!</li>
                  <h5>🎯 How to Add Users</h5>
                  <p>You can add users in two easy ways:</p>
                  <h6> 1️⃣ Referral Link</h6>
                  <li>
                    Your unique invitation link is shown on your dashboard.
                  </li>
                  <li>
                    Anyone who signs up using this link will be automatically
                    added to your team.
                  </li>
                  <li>You can copy, share, or download a QR code.</li>
                  <h6> 2️⃣ Add New User (Manual)</h6>
                  <li>Tap on "Add New User" and fill in the user's info.</li>
                  <li>
                    The user will instantly be created under your downline.
                  </li>
                  <h5>📊 Your Affiliate Panel Features</h5>
                  <h6>🔹Dashboard</h6>
                  <li>Total users added</li>
                  <li>Total users who deposited</li>
                  <li>Total commission earned</li>
                  <li>Today’s top 5 losing users</li>
                  <li>Referral link &amp; QR code</li>
                  <li>Add user button</li>
                  <h6>🔹User List</h6>
                  <li>See all your downline users</li>
                  <li>View their balance and registration date</li>
                  <li>Tap "Add New User" to add more</li>
                  <li>Filter users by registration date</li>
                  <h6>🔹Profit &amp; Loss</h6>
                  <li>See user profit/loss by date range</li>
                  <li>Breakdown by event (casino, sports, etc.)</li>
                  <li>Total profit, total loss, and net P&amp;L</li>
                  <li>This is used to calculate your daily bonus</li>
                  <h6>🔹Reports</h6>
                  <li>View daily commission report</li>
                  <li>Check how much bonus you earned each day</li>
                  <li>Filter by date range</li>
                  <h6>📌 Important Rules</h6>
                  <p>
                    ✅ You earn commission only if your users lost money overall
                    for that day.
                  </p>
                  <p>✅ Bonus is added daily after 2:00 AM automatically.</p>
                  <p>
                    ✅ No commission if user total P&amp;L is positive (i.e.,
                    users made profit).
                  </p>
                  <p>
                    ✅ You can use both link and manual user addition — both
                    work the same.
                  </p>
                  <p>
                    🚫 Don't misuse the system or create fake users — this may
                    result in suspension.
                  </p>
                </ul>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HowToget
